import React from 'react';
import CascaDeModal from './CascaDeModal';
import { acaoPrincipal } from '../../design';

/**
 * A PERGUNTA DO ESC num formulário (09/10/2026): "Fechar sem salvar?". Decisão do Maestro, opção (b): perguntar é mais
 * barato que perder o digitado, e some tela a tela conforme ela informa `temEdicaoNaoSalva`.
 *
 * ⛔ É uma casca própria, e não o `useConfirm`, porque o PESO está invertido: a ação principal é "Continuar editando", e
 * "Fechar sem salvar" é a destrutiva contornada. E toda saída que não é escolha explícita (Esc, ×, clique fora) quer
 * dizer CONTINUAR: dispensar a pergunta nunca pode jogar fora o que foi digitado.
 */
const DESTRUTIVA_CONTORNADA = 'bg-transparent border border-central-destrutivo text-central-destrutivo hover:bg-central-destrutivo/10';

export default function PerguntaDeFechar({ onContinuar, onFechar }: { onContinuar: () => void; onFechar: () => void }) {
  return (
    <CascaDeModal
      largura='xs'
      titulo='Fechar sem salvar?'
      onClose={onContinuar}
      fecharAoClicarFora
      zIndex='z-[60]'
      corpoClassName='px-5 py-4'
      rodape={
        <div className='ml-auto flex gap-2'>
          <button type='button' onClick={onFechar} className={`px-4 py-2 rounded-lg text-sm ${DESTRUTIVA_CONTORNADA}`}>
            Fechar sem salvar
          </button>
          <button type='button' onClick={onContinuar} autoFocus className={`px-4 py-2 rounded-lg text-sm ${acaoPrincipal}`}>
            Continuar editando
          </button>
        </div>
      }
    >
      <p className='text-sm text-central-texto'>O que foi digitado aqui se perde.</p>
    </CascaDeModal>
  );
}
